module.exports = __webpack_public_path__ + "static/media/PRISM_5023.e3f76923.jpg";